import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate } from '@angular/router';
import { environment } from '../../environments/environment';
import { EventService, SearchTypeEnum } from '../services/event.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectToV2Guard implements CanActivate {

  constructor(private activatedRoute: ActivatedRoute, private eventService: EventService) { }

  canActivate(): boolean {
    if (environment.redirectToV2) {
      const currentEndpoint = window.location.pathname
      const currentQuery = this.activatedRoute.snapshot.queryParams
      const queryString = new URLSearchParams(currentQuery as any).toString()


      if (currentEndpoint == "/auth/login" || currentEndpoint == "/auth/register") {
        window.location.href = "/my-orders"
        return false
      }

      if (currentEndpoint.includes("/event/") || currentEndpoint == "/") {
        window.location.href = `${environment.redirectToV2}`
        return false
      }

      this.eventService.checkTagOrSlug(currentEndpoint.replace("/", "")).then((res) => {
        if (res?.searchType == SearchTypeEnum.Tag) {
          window.location.href = `${environment.redirectToV2}${currentEndpoint}${queryString ? `?${queryString}` : ''}`
        } else {
          window.location.href = `${environment.redirectToV2}${queryString ? `?${queryString}` : ''}`
        }
      })

      return false;
    }
    return true;
  }
} 